import React, { ComponentProps, FunctionComponent } from "react";

const ScriptIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 12 14",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M3.5 4.5C5.45262 4.5 8.5 4.5 8.5 4.5M3.5 7H8.5M3.5 9.5H6H8.5M1 3C1 1.89543 1.89543 1 3 1H9C10.1046 1 11 1.89543 11 3V11C11 12.1046 10.1046 13 9 13H3C1.89543 13 1 12.1046 1 11V3Z",
      stroke: "currentColor",
    })
  );
};

const ForwardRef = React.forwardRef(ScriptIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
